import { apiClient } from '@/plugins/axios'; // Import your axios instance


const getClients = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/clients?' + params.toString()); // Let the error bubble up
};

const getClientById = async (id: number) => {
  return await apiClient.get(`/clients/${id}`); // Fetch car listing by ID
};

const createClient = async (clientData: any) => {
  return await apiClient.post('/clients', clientData); // Create a new car listing
};

const updateClient = async (id: number, clientData: any) => {
  return await apiClient.patch(`/clients/${id}`, clientData); // Update car listing by ID
};

const deleteClient = async (id: number) => {
  return await apiClient.delete(`/clients/${id}`); // Delete car listing by ID
};

const mergeClients = async (payload: { client_ids: number[]; primary_client_id: number }) => {
  return await apiClient.post('/clients/merge', payload);
};

const searchClientsAndLeads = async (filters: Record<string, any> = {}) => {
  const params = new URLSearchParams(filters as any);
  return apiClient.get('/search-clients-and-leads?' + params.toString()); // Let the error bubble up
};

const exportCSV = async (params: string, body: any) => {
  return await apiClient.post(`/clients/export?${params}`, body, {
    responseType: 'blob',
    headers: {
      'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
    }
  });
};

export default {
  getClients,
  getClientById,
  createClient,
  updateClient,
  deleteClient,
  mergeClients,
  searchClientsAndLeads,
  exportCSV
};
